import * as trace from 'owa-trace';
import { HttpStatusCode, HttpReadyState } from 'owa-http-status-codes';
import type { MailboxInfo } from 'owa-client-ids';
import { getDefaultRequestHeaders } from 'owa-headers';

export default function sendOwsAttachmentRequest(
    url: string,
    requestObject: any,
    owaActionRequestHeader: string,
    mailboxInfo: MailboxInfo,
    contentBlob?: Blob,
    onProgressHandler?: (e: ProgressEvent) => void
): Promise<any> {
    return new Promise(async (resolve, reject) => {
        const request: XMLHttpRequest = new XMLHttpRequest();
        request.onreadystatechange = function () {
            if (request.readyState === HttpReadyState.Done) {
                if (request.status === HttpStatusCode.OK) {
                    let response;
                    try {
                        response = JSON.parse(request.responseText);
                    } catch (error) {
                        trace.errorThatWillCauseAlert(
                            'Attachment: Deserialize response failed with error: ' + error.Message
                        );
                        trace.errorThatWillCauseAlert(
                            'Attachment: Deserialize response Failure Stack Trace: ' + error.stack
                        );
                        reject(error);
                    }

                    resolve(response);
                } else {
                    reject(
                        new Error(
                            'Request failed with status ' +
                                request.status +
                                '. Message: ' +
                                request.responseText
                        )
                    );
                }
            }
        };

        request.ontimeout = function () {
            reject(new Error('Request timed out'));
        };

        if (onProgressHandler) {
            request.upload.onprogress = onProgressHandler;
        }

        request.open('POST', url, true);
        request.setRequestHeader('X-OWA-Action', owaActionRequestHeader);

        // Add other default headers
        const headers = await getDefaultRequestHeaders(mailboxInfo);
        if (headers) {
            Object.keys(headers).forEach(headerName => {
                request.setRequestHeader(headerName, headers[headerName]);
            });
        }

        const serializedRequest: string = JSON.stringify(requestObject);
        if (contentBlob) {
            // Encodes UrlPostData making sure "; , / ? : @ & = + $" and some other characters
            // are not touched.
            request.setRequestHeader('X-OWA-UrlPostData', encodeURI(serializedRequest));
            request.send(contentBlob);
        } else {
            request.send(serializedRequest);
        }
    });
}
